import Player from './LiveStreamPlayer';
import Logger from './LiveStreamPlayerLogger';
import MessageListener from './LiveStreamPlayerMessageListener';
import Root from './LiveStreamPlayerRoot';
import StatsLogger from './LiveStreamPlayerStatsLogger';
import StatsTrigger from './LiveStreamPlayerStatsTrigger';
import VisibilityHandler from './LiveStreamPlayerVisibilityHandler';

const LiveStreamPlayer = {
  Player,
  MessageListener,
  Logger,
  Root,
  StatsLogger,
  StatsTrigger,
  VisibilityHandler,
};

export default LiveStreamPlayer;
